import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MobileStepper from '@mui/material/MobileStepper';
import Typography from '@mui/material/Typography';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { ButtonRow, FormCheckBox, FormStepper, useTrackedFormik } from '@omnigenbiodata/ui';
import InnerLayout from '../../../../layout/Inner';
import ROUTES from '../../../../core/constants/routes.constant';
import { ENROLMENT_STEPS, MESSAGES, TOTAL_CONSENT_STEPS } from '../../../../core/constants/forms.constant';
import { useAppDispatch } from '../../../../store';
import { stepForward } from '../../../../store/enrolment';

const validationSchema = yup.object({
  consent3: yup.boolean().oneOf([true], MESSAGES.consentRequired),
});

function Consent3() {
  const { t } = useTranslation('consent');
  const dispatch = useAppDispatch();
  const navigateTo = useNavigate();
  const formik = useTrackedFormik(
    {
      initialValues: { consent3: false },
      validationSchema: validationSchema,
      onSubmit: (values) => {
        dispatch(stepForward(values));
        navigateTo(ROUTES.enrolmentConsent4);
      },
    },
    'enrol-consent3',
  );

  return (
    <InnerLayout>
      <form onSubmit={formik.handleSubmit}>
        <Box my={3}>
          <FormStepper steps={ENROLMENT_STEPS} activeStep={1} />
        </Box>

        <Box mb={8}>
          <Paper elevation={5}>
            <Box p={3}>
              <Typography variant="h4" component="h1" align="center" gutterBottom>
                3. {t('section3.title')}
              </Typography>
              <MobileStepper
                backButton={false}
                nextButton={false}
                variant="dots"
                steps={TOTAL_CONSENT_STEPS}
                position="static"
                activeStep={2}
              />
              <Typography variant="body1" component="span" align="left">
                <ReactMarkdown>{t('section3.body')}</ReactMarkdown>
              </Typography>
              <FormCheckBox
                error={formik.errors.consent3}
                name="consent3"
                label={t('confirmation')}
                onChange={formik.handleChange}
                touched={formik.touched.consent3}
                value={formik.values.consent3}
              />
            </Box>
          </Paper>
        </Box>
        <ButtonRow buttonSize="large" forwardColor="primary" />
      </form>
    </InnerLayout>
  );
}

export default Consent3;
